import { createContext, ReactElement } from "react";

import { ContextState } from "./types";
import useBookTutorForSubjectContextValue from "./values/useBookTutorForSubjectContextValue";

export const ParentContext = createContext<ContextState | undefined>(undefined);

type Props = { children: ReactElement };

export default function ParentContextProvider({ children }: Props) {
  const bookTutorForSubjectContextValue = useBookTutorForSubjectContextValue();

  const contextValue = {
    ...bookTutorForSubjectContextValue
  };

  return (
    <ParentContext.Provider value={contextValue}>
      {children}
    </ParentContext.Provider>
  );
}
